import { node } from 'prop-types';
import styled from 'styled-components';

const SectionWrapper = styled.div`
  background-color: ${({theme}) => theme.colors.white};
  box-shadow: rgb(214 217 223) 0px 0px 4px;
  margin-bottom: 1.5rem;
  padding: 1.5rem 2rem;
  position: relative;
`;

function BasicSection({ children }) {

  return (
    <SectionWrapper>
      {children}
    </SectionWrapper>
  );
}

BasicSection.propTypes = {
  children: node.isRequired,
};

BasicSection.defaultProps = {
}

export default BasicSection;